import { handleActions } from 'redux-actions';

import { SetSelectedPassengerId, setSelectedPassengerId } from './actions';

const initialState = 0;

const selectedPassengerIdReducer = handleActions(
	{
		[setSelectedPassengerId.toString()]: (_, { payload }: SetSelectedPassengerId) => payload
	},
	initialState
);

export default selectedPassengerIdReducer;
